import { forwardRef } from "react";
const SvgBox = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g clipPath="url(#clip0_4363_57898)"><path d="M1 4L8 7.72727M1 4V12.2727L8 15M1 4L8 1L15 4M8 7.72727V15M8 7.72727L15 4M8 15L15 12.2727V4" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g><defs><clipPath id="clip0_4363_57898"><rect width={16} height={16} fill="currentColor" /></clipPath></defs></svg>;
const ForwardRef = forwardRef(SvgBox);
export default ForwardRef;